<template>
  <section id="app-wrapper">
    <router-view />
  </section>
</template>

<script>
export default {
  name: "AuthLayout",
};
</script>

<style lang="scss" scoped></style>
